export default async function loadData ({ docId, get }) {
  const { data: product } = await get({
    url: `api/model/products/${docId}`,
  })
  const { data: priceRanges } = await get({
    url: 'api/model/priceRanges',
    query: {
      query: { productRef: `ObjectId('${docId}')` },
      sort: { key: 1 },
    },
  })
  return { product, priceRanges }
}



// WEBPACK FOOTER //
// ./src/components/RangeEditor/loadData.js